import React, { Component } from 'react';

import Page from '../page';
import Terms from '../terms';

export default class extends Component {

    render() {

        return (
            <Page {...this.props}>
                <Terms />
            </Page>
        );
    }
};
